// Two places a sheet offers to what it shows (components/Sheet.tsx; Voice Dock, 2026-10-13):
//   - `dock`: the sheet's foot. Content portalled there stays pinned while the body scrolls on its own above
//     it (the panel becomes a column: head · body · dock, the dock at most 40 % of it).
//   - `swap`: in place of the body. Content portalled there replaces the body while it is shown (the
//     recorder's "Analyysi ›" and "Muokkaa…" swap the word away and back with "‹ Sana").
// A component outside any sheet gets null and renders in place. Being inside a sheet also tells a
// play control not to open its line (margin/LinePlay.tsx: a tap must never close the sheet it is in).
import { createContext, useContext, useLayoutEffect } from 'react';

export interface SheetSlots {
  dock: HTMLElement | null;
  swap: HTMLElement | null;
  /** Count a user of the dock (the panel lays out as a column while any is mounted). */
  holdDock: () => () => void;
  /** Count a user of the swap (the body is hidden while any is mounted). */
  holdSwap: () => () => void;
}

export const SheetSlotsContext = createContext<SheetSlots | null>(null);

/** The open sheet this component is in (null: not in a sheet). */
export function useSheetSlots(): SheetSlots | null {
  return useContext(SheetSlotsContext);
}

/** While `on`, hold the sheet's dock or swap (nothing outside a sheet). */
export function useHoldSlot(slots: SheetSlots | null, which: 'dock' | 'swap', on: boolean): void {
  useLayoutEffect(() => {
    if (!slots || !on) return;
    return which === 'dock' ? slots.holdDock() : slots.holdSwap();
  }, [slots, which, on]);
}
